// @ts-check
import RoleOption from "./option.js";

RoleOption.define();

export default RoleOption;
export * from './option.js';

/**
 * @type {import("./option-globals.js")}
 */
